import { ApplicationRoutes } from '../../../app-routes-names'
import { FormType, InspectionFormType } from 'form-data-access'

export const OfficialFormsRoutes = {
  cashDrawerSummary: 'cash-drawer-summary',
  cashDrawerDetails: 'cash-drawer-details',
  cashDrawerDetailsWithId: 'cash-drawer-details/:id',
  weeklyTireCountSummary: 'weekly-tire-count-summary',
  weeklyTireCountDetails: 'weekly-tire-count-details',
  weeklyTireCountDetailsWithId: 'weekly-tire-count-details/:id',
  weeklyTireReportSummary: 'weekly-tire-report-summary',
  weeklyTireReportDetails: 'weekly-tire-report-details',
  weeklyTireReportDetailsWithId: 'weekly-tire-report-details/:id',
  curbAppealSummary: 'curb-appeal-summary',
  curbAppealDetails: 'curb-appeal-details',
  curbAppealDetailsWithId: 'curb-appeal-details/:id',
  curbAppealView: 'curb-appeal-details/:id/view',
  showroomSummary: 'showroom-summary',
  showroomDetails: 'showroom-details',
  showroomDetailsWithId: 'showroom-details/:id',
  showroomView: 'showroom-details/:id/view',
  inspectionCompliance: 'inspection-compliance'
}

const { officialForms } = ApplicationRoutes

export const OfficialFormsPaths = {
  cashDrawerSummary: `/${officialForms}/${OfficialFormsRoutes.cashDrawerSummary}`,
  cashDrawerDetails: `/${officialForms}/${OfficialFormsRoutes.cashDrawerDetails}`,
  cashDrawerDetailsWithId: (id: string) =>
    `/${officialForms}/${OfficialFormsRoutes.cashDrawerDetailsWithId.replace(':id', id)}`,
  weeklyTireCountSummary: `/${officialForms}/${OfficialFormsRoutes.weeklyTireCountSummary}`,
  weeklyTireCountDetails: `/${officialForms}/${OfficialFormsRoutes.weeklyTireCountDetails}`,
  weeklyTireCountDetailsWithId: (id: string) =>
    `/${officialForms}/${OfficialFormsRoutes.weeklyTireCountDetailsWithId.replace(':id', id)}`,
  weeklyTireReportSummary: `/${officialForms}/${OfficialFormsRoutes.weeklyTireReportSummary}`,
  weeklyTireReportDetails: `/${officialForms}/${OfficialFormsRoutes.weeklyTireReportDetails}`,
  weeklyTireReportDetailsWithId: (id: string) =>
    `/${officialForms}/${OfficialFormsRoutes.weeklyTireReportDetailsWithId.replace(':id', id)}`,
  curbAppealSummary: `/${officialForms}/${OfficialFormsRoutes.curbAppealSummary}`,
  curbAppealDetails: `/${officialForms}/${OfficialFormsRoutes.curbAppealDetails}`,
  curbAppealDetailsWithId: (id: string) =>
    `/${officialForms}/${OfficialFormsRoutes.curbAppealDetailsWithId.replace(':id', id)}`,
  curbAppealView: (id: string) =>
    `/${officialForms}/${OfficialFormsRoutes.curbAppealView.replace(':id', id)}`,
  showroomSummary: `/${officialForms}/${OfficialFormsRoutes.showroomSummary}`,
  showroomDetails: `/${officialForms}/${OfficialFormsRoutes.showroomDetails}`,
  showroomDetailsWithId: (id: string) =>
    `/${officialForms}/${OfficialFormsRoutes.showroomDetailsWithId.replace(':id', id)}`,
  showroomView: (id: string) =>
    `/${officialForms}/${OfficialFormsRoutes.showroomView.replace(':id', id)}`,
  inspectionCompliance: `/${officialForms}/${OfficialFormsRoutes.inspectionCompliance}`
}

export interface IInspectionPage {
  title: string
  summary: string
  edit: (id: string) => string
  view: (id: string) => string
}

export const InspectionPages: Record<InspectionFormType, IInspectionPage> = {
  [FormType.CurbAppeal]: {
    title: 'Curb Appeal Inspection',
    summary: OfficialFormsPaths.curbAppealSummary,
    edit: OfficialFormsPaths.curbAppealDetailsWithId,
    view: OfficialFormsPaths.curbAppealView
  },
  [FormType.ShowroomInspection]: {
    title: 'Showroom Inspection',
    summary: OfficialFormsPaths.showroomSummary,
    edit: OfficialFormsPaths.showroomDetailsWithId,
    view: OfficialFormsPaths.showroomView
  }
}

// For callers holding any FormType; undefined for forms without a view mode
export function inspectionPage(type: FormType): IInspectionPage | undefined {
  return type === FormType.CurbAppeal || type === FormType.ShowroomInspection
    ? InspectionPages[type]
    : undefined
}
